import React, {useState} from 'react';
import { Link, useLocation, Outlet} from 'react-router-dom';
import useWindowSize from '../../hooks/useWindowSize';
import IconClose from '../common/asset/images/icon-close.svg';

import { CommingSoon } from '../common/component';
  
const dataTabs = [
    {to: '/ino/upcoming', title: 'Upcoming'},
    {to: '/ino/opening', title: 'Opening'},
    {to: '/ino/ended', title: 'Ended'},
    // {to: '/ino/bought', title: 'Bought'}, 
];

const InoLaunchPad = () => {
    const [isOpenTab, setIsOpenTab] = useState(false);
    const [commingSoon, setCommingSoon] = useState(false);
    let location = useLocation();
    const size = useWindowSize();
    const sizeTablet = 767;
    let myPathname = location.pathname;
    const sep = /\//;
    let isPathname = myPathname.split(sep);
    
    const elmMenuTabs = dataTabs.map((item,key) => {
        let myTab = item.to;
        let isTabName = myTab.split(sep);  

        return(
            <li key={key} className={isPathname[2]===isTabName[2] ? 'is-active' : ''}>
                <Link onClick={() => setIsOpenTab(false)} to={item.to}>{item.title}</Link>
                {item.ask && <div className="c-tabs__ask">
                    {item.ask}
                    <p>Claimable includes projects that will be claimed in the current month</p>
                </div>}
            </li>
        );
    });

    if(commingSoon) {
        return <CommingSoon />
    } 
    return(
        <div className="p-launchpad p-ino">
            {isOpenTab ? <div className="c-bgSP"></div> : ''}
            <div className="c-tabs">
                {size.width <= sizeTablet ? <div className="c-tabs__navSP" onClick={() => setIsOpenTab(true)}>{isPathname[2]}</div> : ''}
                <ul className={`c-tabs__nav ${isOpenTab ? 'is-open' : ''}`}>
                    {size.width <= sizeTablet ? <li className="is-close">Status<span onClick={() => setIsOpenTab(false)}><img src={IconClose} alt="Close" /></span></li> : ''}
                    {elmMenuTabs}
                </ul>
                <div className="c-tabs__content">
                    <Outlet />
                </div>
            </div>
        </div>
    );
};

export default InoLaunchPad;